import { CustomerAPI } from 'api'

export const getContactPropertyDefinitions = () => {
  return CustomerAPI.get(`/property_definitions`)
}
